/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Booking_Portal_Hours_MinutesInputs */

const en_booking_portal_hours_minutes = /** @type {(inputs: Booking_Portal_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} h ${i?.minutes} min`)
};

const pl_booking_portal_hours_minutes = /** @type {(inputs: Booking_Portal_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} godz. ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{hours} h {minutes} min" |
*
* @param {Booking_Portal_Hours_MinutesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_hours_minutes = /** @type {((inputs: Booking_Portal_Hours_MinutesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Hours_MinutesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_hours_minutes(inputs)
	return en_booking_portal_hours_minutes(inputs)
});